import FlexBox from '@sharedComponents/FlexBox';
import InputText from '@sharedComponents/InputText';
import Button from '@src/components/Button';
import FormGroup from '@src/components/FormGroup';
import Select from '@src/components/Select';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const UserForm = ({ user, onSubmit }) => {
    const { t } = useTranslation('bo');
    const methods = useForm({
        defaultValues: {
            firstName: user?.firstName || '',
            lastName: user?.lastName || '',
            email: user?.email || '',
            role: user?.roles?.[0] || '',
        },
    });

    const roleOptions = [
        { value: 'ROLE_ADMIN', label: t('Administrator') },
        { value: 'ROLE_TECH', label: t('Tech') },
        { value: 'ROLE_CATALOGUE', label: t('Catalogue') },
        { value: 'ROLE_PRODUCT', label: t('Product') },
        { value: 'ROLE_CSM', label: t('CSM') },
        { value: 'ROLE_SALES', label: t('Sales') },
    ];

    const handleSubmit = async ({ role, ...data }) => {
        try {
            await onSubmit({ ...data, roles: role ? [role] : [] }, user ? user.uuid : null);
        } catch (error) {
            if (error.code === 'XXX' && error.message === 'User already exist') {
                methods.setError('email', {
                    type: 'manual',
                    message: t('User already exists'),
                });
            }
        }
    };

    return (
        <FormProvider {...methods}>
            <FlexBox gap="m" flexDirection="column">
                <form onSubmit={methods.handleSubmit(handleSubmit)}>
                    <FormGroup label={t('First Name')} errorMsg={methods.formState.errors.firstName?.message}>
                        <InputText
                            type="text"
                            {...methods.register('firstName', {
                                required: t('Please enter a first name'),
                            })}
                            onBlur={() => methods.trigger('firstName')}
                            isError={methods.formState.errors.firstName}
                        />
                    </FormGroup>
                    <FormGroup label={t('Last Name')} errorMsg={methods.formState.errors.lastName?.message}>
                        <InputText
                            type="text"
                            {...methods.register('lastName', {
                                required: t('Please enter a last name'),
                            })}
                            onBlur={() => methods.trigger('lastName')}
                            isError={methods.formState.errors.lastName}
                        />
                    </FormGroup>
                    <FormGroup label={t('Email')} errorMsg={methods.formState.errors.email?.message}>
                        <InputText
                            type="text"
                            {...methods.register('email', {
                                required: t('Please enter an email'),
                            })}
                            onBlur={() => methods.trigger('email')}
                            isError={methods.formState.errors.email}
                        />
                    </FormGroup>
                    <FormGroup label={t('Role')} errorMsg={methods.formState.errors.role?.message}>
                        <Select control={methods.control} register={{ name: 'role' }} options={roleOptions} />
                    </FormGroup>
                </form>
                <FlexBox justifyContent="center">
                    <Button label={t('Validate')} action={methods.handleSubmit(handleSubmit)} disabled={!methods.formState.isValid} />
                </FlexBox>
            </FlexBox>
        </FormProvider>
    );
};

export default UserForm;
